import axios from 'axios';
import { logger, LogEntity } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';

const TIMEOUT = 5000;
const RETRY_INTERVAL = 500;

export const initSellersSearch = async ({ briefId }: { briefId: string }) => {
    const startTime = Date.now();
    while (Date.now() - startTime < TIMEOUT) {
        try {
            const response = await axios.get(pathfinder('get_sellers_to_invite', { brief_id: briefId }), {
                params: {
                    isInitializationRequest: true,
                },
            });

            if (response.status === 200) {
                return;
            }
            if (response.status !== 204) {
                throw new Error(`Failed to request sellers with status code ${response.status}`);
            }
        } catch (error) {
            logger.error(error as LogEntity, {
                description: `Error requesting search_sellers to init brief ${briefId}`,
            });
            return;
        }

        await new Promise((resolve) => setTimeout(resolve, RETRY_INTERVAL));
    }
};
